export const initialFieldValues = {
  old_password: '',
  password: '',
};
